import { useCheckPermissions } from '@/shared';
import { SaveGastos } from '../../shared/components';
import { PermissionsEnum } from '@/auth/interfaces';

export type CreateGastosPageProps = {};

const CreateGastosPage: React.FC<CreateGastosPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_gasto)

  return <SaveGastos titlePage="Crear Gastos" />;
};

export default CreateGastosPage;
